<!-- ButtonCellRenderer.vue -->
<template>
  <div>
    <button class="btn btn-primary" style="position: relative;"
            data-toggle="modal"
            data-target="#listModal"
            @click="handleListButtonClick">List</button>&nbsp;
    <button class="btn btn-warning" style="position: relative;"
            data-toggle="modal"
            data-target="#exampleModal"
            @click="handleEditButtonClick">Edit</button>&nbsp;
    <button class="btn btn-danger" style="position: relative;" @click="handleDeleteButtonClick">Delete</button>&nbsp;
  </div>
</template>

<script>
import eventBus from '@/views/eventBus';

export default {
  props: {
    params: {
      type: Object,
    },
  },
  methods: {
    handleEditButtonClick() {
      // Implement the button click logic here
      // You can access the row data using this.params.node.data
      // For example: this.params.node.data.id
      // console.log('Button clicked for row:', this.params.node.data);
      var rowNode = this.params.node.rowIndex
      // const getConfirm = confirm('You are going to hide this feedback!');
      // if (getConfirm) {
        const eventData = {
          rowNode: rowNode,
          url: '/feedback/hideFeedback',
          id: this.params.data._id,
          data: this.params.data
        };
        eventBus.emit('handleEditButtonClick', eventData) //like this
      // }
      // You can also emit a custom event to notify the parent component of the button click
      // For example: this.$emit('button-click', this.params.node.data);
    },
    handleListButtonClick() {
      // Implement the button click logic here
      // You can access the row data using this.params.node.data
      // For example: this.params.node.data.id
      // console.log('Button clicked for row:', this.params.node.data);
      var rowNode = this.params.node.rowIndex
        const eventData = {
          rowNode: rowNode,
          url: '/feedback/hideFeedback',
          id: this.params.data._id,
          data: this.params.data
        };
        eventBus.emit('handleListButtonClick', eventData) //like this
    },
    handleDeleteButtonClick() {
      // Implement the button click logic here
      // You can access the row data using this.params.node.data
      // For example: this.params.node.data.id
      // console.log('Button clicked for row:', this.params.node.data);
      var rowNode = this.params.node.rowIndex
      const getConfirm = confirm('You are going to delete this group!');
      if (getConfirm) {
      const eventData = {
        rowNode: rowNode,
        url: '/feedback/hideFeedback',
        id: this.params.data._id,
        data: this.params.data
      };
      eventBus.emit('handleDeleteButtonClick', eventData) //like this
      }
      // You can also emit a custom event to notify the parent component of the button click
      // For example: this.$emit('button-click', this.params.node.data);
    },
  },
};
</script>

<style scoped>
/* Add any custom styles for your button cell here */
</style>
